import { AssetHeader } from "@/features/assets/assetParts";
import { InstallPanel } from "@/features/pwa/InstallPanel";

export default function HomeScreenPage() {
  return (
    <div data-testid="home-screen-page" className="mw-rise space-y-8">
      <AssetHeader eyebrow="Home Screen" title="MetWorth on your home screen." description="Open your dashboard like an app, one tap from your home screen." />
      <section className="rounded-lg border border-border bg-card p-5 sm:p-6"><InstallPanel /></section>
    </div>
  );
}
